import graphqlClient from '~/graphql/graphqlClient';

export interface MutationResetAbilitiesArgs {
  playerId: string;
  heroHandle: string;
  heroBuildId: string;
}

export interface AbilityChangeResult {
  heroHandle: string;
  heroBuild: any;
}

const mutation = `
mutation ResetAbilities(
  $playerId: String!
  $heroHandle: String!
  $heroBuildId: String!
) {
  resetAbilities(
    playerId: $playerId
    heroHandle: $heroHandle
    heroBuildId: $heroBuildId
  ) {
    heroHandle
    heroBuild
  }
}`;

export default async function mutationResetAbilities(args: MutationResetAbilitiesArgs) {
  return await graphqlClient.request<AbilityChangeResult>('resetAbilities', mutation, args);
}
